import React, { useState } from "react";
import Header from "../site/Header";
import Footer from "../site/Footer";
import CookieBanner from "../site/CookieBanner";
import LegalModal from "../site/LegalModal";

export default function ShopLayout({ children }) {
  const [legal, setLegal] = useState(null);
  return (
    <div className="bg-offwhite min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer onOpenLegal={setLegal} />
      <CookieBanner onOpenPolicy={setLegal} />
      <LegalModal type={legal} onClose={() => setLegal(null)} />
    </div>
  );
}

export const AVAIL_STYLE = {
  Tilgjengelig: "bg-green-100 text-green-700",
  Reservert: "bg-warm/30 text-navy",
  Solgt: "bg-red-100 text-red-700",
};

export const SHOP_CATEGORIES = ["Telefoner", "Deksel", "Skjermbeskyttere", "Powerbanker", "Annet tilbehør"];

export const SPEC_LABELS = {
  model: "Modell",
  storage: "Lagring",
  color: "Farge",
  battery_health: "Batterihelse",
  repairs_info: "Reparasjoner / byttede deler",
  compatible_models: "Passer til",
};
